(function() {
    'use strict';

    document.addEventListener("DOMContentLoaded", () => {
        const mq = window.matchMedia("(min-width: 992px)");

        // Sticky header scroll behavior
        const handleScroll = () => {
            const header = document.getElementById('header');
            if (!header) return;
            header.classList.toggle('scrolled', window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        const setDesktopBehavior = () => {
            // Desktop: Remove Bootstrap data attributes to allow CSS hover and link navigation
            document
                .querySelectorAll(".slipstream-navbar a.dropdown-toggle[data-bs-toggle='dropdown']")
                .forEach((a) => {
                    a.removeAttribute("data-bs-toggle");
                    a.removeAttribute("aria-expanded");
                    a.removeAttribute("role");
                });
        };

        const setMobileBehavior = () => {
            // On mobile: Toggle submenus when plus button is clicked
            document
                .querySelectorAll(".slipstream-navbar .submenu-toggle")
                .forEach((btn) => {
                    if (btn.dataset.bound === "1") return;
                    btn.dataset.bound = "1";

                    btn.addEventListener("click", (e) => {
                        if (mq.matches) return;

                        e.preventDefault();
                        e.stopPropagation();

                        const li = btn.closest("li");
                        if (!li) return;

                        const submenu = li.querySelector(":scope > .dropdown-menu");
                        if (!submenu) return;

                        const willOpen = !submenu.classList.contains("show");

                        // Close siblings
                        const siblings = li.parentElement?.querySelectorAll(":scope > li");
                        siblings?.forEach((sib) => {
                            if (sib === li) return;
                            sib.classList.remove("show");
                            const sm = sib.querySelector(":scope > .dropdown-menu");
                            sm?.classList.remove("show");
                            const sibBtn = sib.querySelector(":scope > .submenu-toggle");
                            if (sibBtn) sibBtn.setAttribute("aria-expanded", "false");
                        });

                        // Toggle current
                        submenu.classList.toggle("show", willOpen);
                        li.classList.toggle("show", willOpen);
                        btn.setAttribute("aria-expanded", willOpen ? "true" : "false");
                    }, { passive: false });
                });
        };

        const apply = () => {
            if (mq.matches) {
                setDesktopBehavior();
            } else {
                setMobileBehavior();
            }
        };

        apply();
        mq.addEventListener?.("change", apply);
    });
})();
